const initials = "questions/";

export const UPDATE_QUESTIONS = `${initials}UPDATE_QUESTIONS`;
export const UPDATE_FILTER = `${initials}UPDATE_FILTER`;
export const UPDATE_REDUCER = `${initials}UPDATE_REDUCER`;